import React from 'react';


const styles = `
.info-festas-page {
  min-height: 100vh;
  background-color: white;
}

/* Hero Section */
.info-hero {
  padding: 4rem 0 3rem;
  text-align: center;
  background: linear-gradient(to bottom, #f0f9f9, white);
}

.container {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 1rem;
}

.info-title {
  font-size: 3rem;
  color: #5A9C9C;
  margin-bottom: 2rem;
  font-weight: 300;
  letter-spacing: 0.025em;
}

/* Content Section */
.info-content {
  padding: 3rem 0;
  background-color: #fef3c7;
}

.content-box {
  max-width: 800px;
  margin: 0 auto;
  background-color: white;
  padding: 3rem 2.5rem;
  border-radius: 0.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.menu-badge {
  display: inline-block;
  background-color: #b2e8e8;
  color: #4A8080;
  padding: 1rem 2rem;
  border-radius: 50px;
  font-size: 1.125rem;
  margin-bottom: 2rem;
  font-weight: 500;
}

.info-subtitle {
  font-size: 1.125rem;
  color: #4A8080;
  margin-bottom: 1rem;
  text-align: center;
}

.info-duration {
  font-size: 1rem;
  color: #6b7280;
  margin-bottom: 2rem;
  text-align: center;
}

.info-description {
  color: #4b5563;
  line-height: 1.8;
  margin-bottom: 2rem;
  text-align: center;
}

.section-heading {
  font-size: 1.25rem;
  color: #4A8080;
  margin: 2rem 0 1rem;
  font-weight: 600;
}

.info-list {
  list-style: none;
  padding: 0;
  margin-bottom: 2rem;
}

.info-list li {
  padding: 0.5rem 0;
  color: #4b5563;
  line-height: 1.6;
}

.info-list li::before {
  content: "• ";
  color: #5A9C9C;
  font-weight: bold;
  margin-right: 0.5rem;
}

.decoration-section {
  background-color: #f9fafb;
  padding: 1.5rem;
  border-radius: 0.5rem;
  margin: 2rem 0;
}

.decoration-items {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
  margin-top: 1rem;
}

.decoration-items li {
  background-color: white;
  padding: 0.75rem;
  border-radius: 0.375rem;
  border-left: 3px solid #5A9C9C;
}

.price-section {
  text-align: center;
  margin-top: 3rem;
  padding-top: 2rem;
  border-top: 2px solid #e5e7eb;
}

.price {
  font-size: 2.5rem;
  color: #5A9C9C;
  font-weight: 600;
  margin-bottom: 1rem;
}

.price-note {
  color: #6b7280;
  font-size: 0.95rem;
  line-height: 1.6;
  margin-top: 1rem;
}

/* Responsive */
@media (max-width: 768px) {
  .info-title {
    font-size: 2rem;
  }

  .content-box {
    padding: 2rem 1.5rem;
  }

  .price {
    font-size: 2rem;
  }

  .decoration-items {
    grid-template-columns: 1fr;
  }
}
`;

export default function InfoFestaPage() {
  return (
    <>
      <style>{styles}</style>
      <div className="info-festas-page">
        <section className="info-hero">
          <div className="container">
            <h1 className="info-title">Festas Aniversário</h1>
          </div>
        </section>

        <section className="info-content">
          <div className="container">
            <div className="content-box">
              <div style={{ textAlign: 'center' }}>
                <span className="menu-badge">Menu Barco de Papel</span>
              </div>

              <p className="info-subtitle">
                Crianças e pais do Aniversariante
              </p>
              <p className="info-duration">Duração 2h30m</p>

              <p className="info-description">
                A festa com Pacote Especial conta um menu para crianças, Educadora Especializada,
                animadora e a decoração da mesa do bolo com tema à escolha confecionado por Cake
                Designer
              </p>

              <h3 className="section-heading">Espaço Brincoteca:</h3>
              <p className="info-description">
                Brincadeira na zona lúdica, utilização dos jogos, brinquedos e adereços de fantasia
                disponíveis dentro do espaço Barco de Papel
              </p>

              <h3 className="section-heading">Espaço Artístico:</h3>
              <p className="info-description">
                Atividade artística com Projeto para criação individual de lembranças da festa ou
              </p>
              <p className="info-description">
                Animação (ex.: mágico ou palhaço ou música ou tatuagens Glitter)
              </p>

              <h3 className="section-heading">Convite eletrónico</h3>

              <div className="decoration-section">
                <h3 className="section-heading" style={{ marginTop: 0 }}>Decoração:</h3>
                <p style={{ color: '#4b5563', marginBottom: '0.5rem' }}>
                  Mesa de Bolo e "Candy Bar"
                </p>
                <p style={{ color: '#4b5563', marginBottom: '1rem' }}>
                  Decoração da mesa/zona do bolo temático confecionado por Cake Designer
                </p>
                <p style={{ color: '#4b5563', fontWeight: '600', marginBottom: '1rem' }}>
                  Pode incluir:
                </p>
                
                <p style={{ color: '#4b5563', marginBottom: '0.5rem' }}>Decoração</p>
                <ul className="decoration-items">
                  <li>Estruturas para decoração</li>
                  <li>Mobiliário</li>
                  <li>Suportes para doces e bolos</li>
                  <li>Loiça decorativa</li>
                  <li>Adereços</li>
                </ul>
              </div>

              <h3 className="section-heading">Bolo de Aniversário</h3>
              <ul className="info-list">
                <li>Pão de Ló + chantilly (15/20 fatias)</li>
              </ul>

              <h3 className="section-heading">Catering (Candy Bar)</h3>
              <ul className="info-list">
                <li>Doces sortidos</li>
                <li>Mini suspiros</li>
                <li>Mini croissants mistos</li>
                <li>Pipocas</li>
                <li>Copos de fruta da época</li>
                <li>Gelatina</li>
                <li>Brigadeiros</li>
              </ul>

              <p className="info-description" style={{ marginTop: '1.5rem' }}>
                Água e sumos, Limonada
              </p>

              <p className="info-description" style={{ fontStyle: 'italic' }}>
                Inclui também descartáveis de copos, pratos, guardanapos, talheres...)
              </p>

              <div className="price-section">
                <div className="price">18€ / criança</div>
                <p className="price-note">
                  Mínimo 15 crianças e máximo 20 crianças + 2 adultos (ex.: pais)
                  <br />
                  Convites impressos acresce 0,20€/convite
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}